<template>
    <div class="chat-box">
      <div class="layout-main">
          <Card :dis-hover="true">
            <div class="search-panel">
              <ul class="list-group">
                
                <li class="list-group-item">
                  <div class="item-label">店铺: </div>
                  <ul class="item-list">
                    <li @click="selectitem('store_id', item.id)" v-for="(item, index) in stores[filter.connector]" :key="index"><span :class="{ active: item.active==true }" class="option-item">{{item.name}}</span></li>
                  </ul>
                </li>
                <li class="list-group-item">
                  <div class="item-label">是否备注: </div>
                  <ul class="item-list">
                    <li @click="selectitem('is_remark', null)" ><span :class="{ active: filter.is_remark===null }" class="option-item">全部</span></li>
                    <li @click="selectitem('is_remark', 1)" ><span :class="{ active: filter.is_remark===1 }" class="option-item">已备注</span></li>
                    <li @click="selectitem('is_remark', 0)" ><span :class="{ active: filter.is_remark===0 }" class="option-item">未备注</span></li>
                  </ul>
                </li>
                <li class="list-group-item">
                  <div class="item-label">搜索: </div>
                  <Input v-model="searchval" style="width: 500px" >
                          <Select v-model="searchfield" slot="prepend" style="width: 80px">
                              <Option value="buyer_name">买家名</Option>
                              <Option value="purchase_skus">SKU</Option>
                          </Select>
                          <Button @click="request(row_index, purchase_state)" slot="append" icon="ios-search"></Button>
                      </Input>
                </li>
                <li class="list-group-item">
                  <div class="item-label">过滤: </div>
                  <Select @on-select="selectFilterBuyer" v-model="filterBuyerId" multiple :max-tag-count="2">
                    <Option v-for="item in buyerFilterList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
                </li>
                
              </ul>
            </div>
            <Divider style="margin: 0px;" dashed />
            <div style="padding: 10px 0px;" class="tools">
              
              <Button @click="request" style="background: #1a242f" type="primary" icon="ios-refresh"></Button>&nbsp;
              <Button @click="buyersMsgModal = true" size="small" type="primary">群发消息</Button>
            </div>
            <Table @on-sort-change="sortEvent" @on-selection-change="selectEvent" @on-select="selectEvent" @on-select-cancel="selectEvent" :loading="loading" :columns="columns" :data="data" height="400">
              <template slot-scope="{ row }" slot="name">
                  <strong>{{ row.name }}</strong>
              </template>
              <template slot-scope="{ row }" slot="store_name">
                  <strong>{{ row.store.name }}</strong>
              </template>
              <template slot-scope="{ row }" slot="last_order_time">
                  <strong>{{ row.last_order_time_text }}</strong>
              </template>
              <template slot-scope="{ row, index }" slot="chat_remarks">
                <Input type="text" v-model="rowEdit.editRemarks" v-if="rowEdit.editIndex === index" />
                <span v-else><font color="#ff0000">{{row.chat_remarks}}</font></span>
              </template>

              <template slot-scope="{ row, index }" slot="action">
                  <div v-if="rowEdit.editIndex === index">
                    <Button @click="handleSave(index)">保存</Button>
                    <Button @click="rowEdit.editIndex = -1">取消</Button>
                  </div>
                  <div v-else>
                    <Icon style="cursor: pointer;" size="20" title="备注" @click="handleEdit(row, index)" type="md-create" />&nbsp;
                    <Icon v-if="false" style="cursor: pointer;" size="20" title="群发消息" @click="buyerMsgShow(row)" type="md-chatboxes" />&nbsp;
                    <Icon style="cursor: pointer;" size="20" title="过滤买家" @click="filterBuyre(row)" type="ios-funnel" />&nbsp;
                    <Icon style="cursor: pointer;" size="20" title="打开聊天" @click="openSession(row)" type="md-ionitron" />&nbsp;
                  </div>

              </template>
            </Table>
            <div class="page-wrap">            
              <Page :total="total" @on-change="switchPage" @on-page-size-change="switchPagesize" show-sizer />
            </div>
          </Card>
      </div>
    <Modal 
        v-model="buyersMsgModal"
        title="群发消息"
        :footer-hide="true"
        width="600"
        >
         <Form :model="buyersMsgForm" :label-width="80">
          <FormItem label="模板">
              <RadioGroup @on-change="changeTemplate" v-model="buyersMsgForm.template_type">
                  <Radio label="txt">文本</Radio>
                  <Radio :disabled="!this.filter.store_id" label="voucher">优惠券</Radio>
              </RadioGroup>
          </FormItem>
          <FormItem v-if="buyersMsgForm.template_type == 'voucher'" label="优惠券">
              <Select v-model="buyersMsgForm.voucher_id">
                  <Option :key="index" v-for="(voucher, index) in voucher_list" :value="voucher.id">{{voucher.voucher_name}}</Option>
                  
              </Select>
          </FormItem>
          <FormItem v-if="buyersMsgForm.template_type == 'txt'" label="群发消息">
            <Input v-model="buyersMsgForm.content" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入群发内容"></Input>
          </FormItem>
          <FormItem>
              <Button @click="buyersMsgSend()" type="primary">确定</Button>
          </FormItem>
        </Form>
    </Modal>
    
    </div>
</template>
<script>
import RequestUtils from "@/utils/RequestUtils";
import conf from "@/views/im/conf";

export default {
  components: {
  },

  data() {
    return {
      loading: false,
      total: 0,
      curPage: 1,
      pageSize: 10,
      searchfield: 'buyer_name',
      searchval: '',
      buyersMsgModal: false,
      buyerMsgModal: false,
      selection: [],
      filterBuyerId: '',
      buyerFilterList: [],
      sortData: {},
      rowEdit: {
        editIndex: -1,  // 当前聚焦的输入框的行数
        editRemarks: ''
      },
      filter: {
        connector: 'lazada',
        row_index: 0,
        purchase_state: '',
        is_remark: null
      },
      buyersMsgForm: {
        template_type: 'txt',
        voucher_id: '',
        content: ''
      },
      buyerMsgForm: {
        id: '',
        buyer_id: '',
        store_id: '',
        content: '',
      },
      voucher_list: [],
      columns: [
          {
              type: 'selection',
              width: 60,
              align: 'center'
          },
          {
              title: '买家名',
              key: 'buyer_name'
          },
          {
              title: '店铺',
              slot: 'store_name'
          },
          {
              title: '最近下单时间',
              key: 'last_order_time',
              slot: 'last_order_time',
              sortable: 'custom'
          },
          {
              title: '电话号码',
              key: 'recipient_phone'
          },
          {
              title: '最后购买的SKU',
              key: 'purchase_skus'
          },
          {
              title: '交易总额',
              key: 'finish_order_amount'
          },
          {
              title: '交易笔数',
              key: 'finish_order_count',
              sortable: 'custom'
          },
          {
              title: '最近群发记录',
              key: 'chat_last_message'
          },
          {
              title: '最近群发时间',
              key: 'chat_last_time_text'
          },
          {
              title: '备注',
              slot: 'chat_remarks'
          },
          {
              title: '操作',
              slot: 'action',
              width: 150,
              align: 'center'
          }
      ],
      data: [
        
      ]
    }
  },
  computed: {
    stores: {
      get: function() {
        return this.$store.state.storeOpt;
      }
    },
  },
  methods: {
    // 筛选
    selectitem (key, value) {
      if (key == 'store_id') {
        this.$store.commit("activeStoreOptById", {
          platform: this.filter.connector,
          id: value
        });
      }
      this.filter[key] = value;
      this.request();
    },
    // 行编辑
    handleEdit (row, index) {
      this.rowEdit.editRemarks = row.chat_remarks;
      this.rowEdit.editIndex = index;
    },
    // 行编辑保存
    handleSave (index) {
      let param = new FormData();
      param.set("id", this.data[index].id );
      param.set("chat_remarks", this.rowEdit.editRemarks );
      param.set("connector", this.filter.connector );
      RequestUtils.request(conf.getHostUrl()+'/lazada/buyer/updateBuyer', param)
      .then(() => {                  
        this.data[index].chat_remarks = this.rowEdit.editRemarks;
        this.rowEdit.editIndex = -1;
      })
    },
    // 切换页面
    switchPage (index) {
      this.curPage = index;
      this.request();
    },
    // 选择页面大小
    switchPagesize (size) {
      this.pageSize = size;
      this.request();
    },
    setStore (store_id) {
      let store = this.stores[this.filter.connector];
      for (let i=0; i<store.length; i++) {
        if (store[i].id == store_id) {
          store[i].active = true;
        } else {
          store[i].active = false;            
        }
      }
      this.filter['store_id'] = store_id;
    },
    // 买家列表
    request () {
      let self = this;
      
      let param = new FormData();
      param.set("page", this.curPage );
      param.set("limit", this.pageSize );
      if (this.searchfield) {      
        param.set(this.searchfield, this.searchval);
      }
      for (let key in this.filter) {
        param.set(key, this.filter[key] );
      }
      if (this.sortData.key) {
        param.set("sort", this.sortData.key );
        param.set("order", this.sortData.order );
      }

      self.loading = true;
      RequestUtils.request(conf.getBuyerModel(), param)
      .then(data => {
        self.total = data.total;
        self.data = data.data;
        let buyerFilterList = new Array();
        for (let i=0; i<data.filterBuyer.length; i++) {
          buyerFilterList.push({
            value: data.filterBuyer[i]['id'],
            label: data.filterBuyer[i]['buyer_name']
          })
        }
        self.buyerFilterList = buyerFilterList;
        self.buildFilterBuyerId();
        self.loading = false;
        this.selection = [];
        this.changeTemplate(this.buyersMsgForm.template_type)
      })
    },
    selectEvent(selection) {
      this.selection = selection;
    },
    sortEvent(data) {
      this.sortData = data;
      this.request();
    },
    // 过滤买家
    filterBuyre(buyer, status) {
      let param = new FormData();
      param.set("id", buyer.id);
      status = status ? status : 0;
      param.set("status", status);
      RequestUtils.request(conf.getHostUrl()+'/lazada/buyer/updateBuyer', param)
      .then(() => {
        this.request();
      })
    },
    buildFilterBuyerId() {
      let filterBuyerId = new Array();
      for (let i=0; i<this.buyerFilterList.length; i++) {
        filterBuyerId.push(this.buyerFilterList[i]['value']);
      }
      this.filterBuyerId = filterBuyerId;
    },
    selectFilterBuyer(selection) {
      for (let i=0; i<this.buyerFilterList.length; i++) {
        if (selection.value == this.buyerFilterList[i].value) {
          this.buyerFilterList.splice(i, 1);
          this.buildFilterBuyerId();
          this.filterBuyre({id: selection.value}, 1);
          break;
        }
      }
    },
    // 群发消息
    buyersMsgSend() {
      let buyer_ids = new Array();
      for (let i=0; i<this.selection.length; i++) {
        buyer_ids.push(this.selection[i].id);
      }
      if (buyer_ids.length == 0) {
        return this.$Message.error('请先选择需要设置的买家');
      }
      let param = new FormData();
      param.set("connector", this.filter.connector);
      param.set("buyer_ids", buyer_ids.join(','));
      param.set("template_type", this.buyersMsgForm.template_type);
      if (this.buyersMsgForm.template_type == 'txt') {
        // 文本模板
        param.set("txt", this.buyersMsgForm.content);  
      } else if (this.buyersMsgForm.template_type == 'voucher') {
        // 优惠券模板
        param.set("voucher_id", this.buyersMsgForm.voucher_id);
      }
      this.buyersMsgModal = false;
      RequestUtils.request(conf.buyersMsgSendQueue(), param)
      .then(() => {
        this.selection = [];
        this.request();
        this.$Message.success('指令已发送成功, 请等待发送完成!');
      })
    },
    // 群发消息
    buyerMsgShow(buyer) {
      this.buyerMsgForm.id = buyer.id;
      this.buyerMsgForm.buyer_id = buyer.buyer_id;
      this.buyerMsgForm.store_id = buyer.store_id;
      this.buyerMsgForm.official_session_id = buyer.official_session_id;
      this.buyerMsgModal = true;
    },
    // 切换消息模板
    changeTemplate(type) {
      if (type == 'voucher') {
        if (!this.filter.store_id) {
          this.$Message.error('发送优惠券模板，必须先选中店铺!');
        }
        let param = new FormData();
        param.set("store_id", this.filter.store_id);
        param.set("voucher_type", 'COLLECTIBLE_VOUCHER');
        RequestUtils.request(conf.getVoucherList(this.filter.connector), param)
        .then((json) => {
          this.voucher_list = json.data_list;
        })
      }
    },
    // 打开聊天
    openSession(row) {
      
      this.$router.push("/chat/main");
      this.$store.commit(this.filter.connector+"/openSession", {
        buyer_id: row.buyer_id,
        store_id: row.store_id
      });

    },
  }
};
</script>
<style lang="scss" scoped>
@import "@/static/styles/theme";

.ivu-tabs-content {
  height: 100%;
}
.page-wrap {
  padding-top: 3rem;
}

.search-panel {
  padding: 2rem;

  .list-group-item {
    display: flex;
    align-items: center;
    border: 0px;
    position: relative;
    padding: 10px 0px;

    .item-label {
      width: 90px;
    }

    .item-list {
      padding: 0px;
      max-height: 120px;
      overflow: scroll;
      overflow-x: hidden;

      li {
        display: inline-block;
        margin: 0px 3px;
        cursor: pointer;
        color: #428bca;

        .option-item {
          padding: 2px 5px;
          border-radius: 3px;
        }
        .option-item.active {
          background: #428bca;
          color: #fff;
        }
      }
    }
  }
}

.panel-box {
  width: 100%;
  background-color: $color-light-gray;
  height: 100%;
  display: flex;
  flex-direction: row;

  .chat-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;

    .layout-main {
      height: 100%;
      overflow-y: scroll;
      padding: 1rem;
      
    }
  }

  
}
</style>
